import { createMemoStyles } from '@wds/utils';
import { HeaderTheme } from '../../theme';

const useStyles = createMemoStyles(({ palette, shadow }: HeaderTheme) => ({
  panel: {
    position: 'absolute',
    top: '100%',
    width: '516px',
    background: palette.background.light,
    boxShadow: shadow.space,
  },
  leftBox: {
    maxWidth: '176px',
    whiteSpace: 'normal',
  },

  rightBox: {
    maxWidth: '300px',
    whiteSpace: 'normal',
    backgroundColor: palette.background.main,
  },

  title: {
    borderBottom: `1px solid ${palette.border.main}`,
  },
}));

export default useStyles;
